
var dropzone_upload = {
    init: function(documentsList, options) {
        var uploadDropzone = new Dropzone("[data-dropzone]", {
            url: options.url || '/Document/Upload',
            maxFilesize: 20000,
            uploadMultiple: options.uploadMultiple || false,
            dictDefaultMessage: 'Dateien hochladen',
            createImageThumbnails: false,
            clickable: options.clickable || documentsList.find('[data-dz-upload]')[0],
            paramName: "File",
            previewTemplate: '<div class="modal dz-preview dz-file-preview" role="dialog">' +
                '  <div class="modal-dialog dz-details">' +
                '    <div class="modal-content">' +
                '      <div class="modal-header">' +
                '        <strong class="modal-title"><div class="dz-filename"><span data-dz-name></span><span class="dz-size" data-dz-size></span></div></strong>' +
                '      </div>' +
                '      <div class="modal-body">' +
                '        <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>' +
                '        <div class="dz-error-message"><span data-dz-errormessage></span></div>' +
                '      </div>' +
                '      <div class="modal-footer" style="display:none;">' +
                '      </div>' +
                '    </div>' +
                '  </div>' +
                '</div>',
            sending: function(file, xhr, formData) {
                documentsList.startProcess();
                formData.append("repositoryId", documentsList.attr('data-repositoryId'));
                formData.append("parentId", documentsList.attr('data-parentid'));
                formData.append("relationType", documentsList.attr('data-relationType'));
                formData.append("relationId", documentsList.attr('data-relationId'));
            },
            addedfile: function (file) {
                var uploadPreview = '<div data-upload="' + file.name + '">' +
                    '  <div class="progress">' +
                    '    <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>' +
                    '  </div>' +
                    '  <span class="message">' + file.name + '</span>' +
                    '</div>';

                toastr.info(uploadPreview, 'Upload ...', {
                    closeButton: true,
                    newestOnTop: false,
                    timeOut: 0,
                    extendedTimeOut: 0
                });
                var uploadToast = $('#toast-container [data-upload="' + file.name + '"]').closest('.toast');
                uploadToast.find('.toast-close-button').hide().prop('disabled', 'disabled');
            },
            uploadprogress: function (file, bytesSent) {
                $('#toast-container [data-upload="' + file.name + '"] .progress-bar').width(bytesSent + '%');
            },
            complete: function (file, message) {
                if (file.accepted) {
                    uploadDropzone.removeFile(file);
                }
                documentsList.endProcess();
            },
            canceled: function (file, message) {
                uploadDropzone.removeFile(file);
            },
            error: function(file, data) {
                var uploadToast = $('#toast-container [data-upload="' + file.name + '"]').closest('.toast');
                uploadToast.removeClass('toast-info').addClass('toast-error');
                uploadToast.find('.toast-close-button').show().prop('disabled', null);
                uploadToast.find('.toast-title').html('Fehler');
                uploadToast.find('.message').append('<br/>' + data.error);
            },
            success: function (f, responseText) {
                var file = responseText.file;
                documentsList.trigger('file-added', { file: f, response: responseText });

                var uploadToast = $('#toast-container [data-upload="' + file.name + '"]').closest('.toast');
                uploadToast.removeClass('toast-info').addClass('toast-success');
                uploadToast.find('.toast-close-button').show().prop('disabled', null);

                setTimeout(function () {
                    uploadToast.remove();
                }, 500);
            },
            queuecomplete: function() {
                documents.loadFolder(documentsList.attr('data-parentid'));
            }
        });
    }
}
window.dropzone_upload = dropzone_upload;

var documents = {
    container: null,
    folderNameEls: null,
    docList: null,
    repositoryId: null,
    uploadEl: null,
    dndUploadEl: null,
    newFolderEl: null,
    refreshEl: null,
    titleEl: null,
    newFolderForm: null,

    init: function(container, options) {
        options = options || {};
        documents.container = container;
        documents.repositoryId = container.attr('data-repositoryId');
        documents.folderNameEls = container.find('.folder-name');
        documents.uploadEl = container.find('[data-upload]');
        documents.newFolderEl = container.find('[data-newfolder]');
        documents.refreshEl = container.find('[data-refresh]');
        documents.newFolderForm = options.newFolderForm || container.find('.newfolder');
        documents.titleEl = documents.container.find('.title');
        documents.dndUploadEl = $('.file-upload');
        documents.refreshEl.click(function() {
            documents.loadFolder(documents.refreshEl.attr('data-refresh'));
        });
        container.find('[data-recalctree]').click(function() {
            connection.getJson($(this).attr('data-recalctree'), {
                onComplete: function() {
                    documents.loadFolder(documents.refreshEl.attr('data-refresh'));
                }
            });
        });
        container.find('[data-level-up]').click(function() {
            var folderUp = documents.container.find('.folder-name .crumb').last();
            if (folderUp.length !== 0) {
                documents.loadFolder(folderUp.attr('data-openfolder'));
            }
        });
        documents.initFilesContextmenu();

        documents.docList = container.find('#docs-' + documents.repositoryId);
        documents.loadFolder('');
        documents.uploadEl.click(documents.uploadFile);
        documents.newFolderEl.click(documents.showCreateFolder);
        documents.newFolderForm.find('[data-save]').off('click').click(function (ev) {
            var controlEl = documents.newFolderForm.find('input');
            documents.createFolder(controlEl, true);
        });
        // documents.newFolderForm.find('input').blur(function() { documents.createFolder($(this), false) });
        $('body').click(documents.bodyClick);

        $(window).on("popstate", function(e) {
            if (e.originalEvent.state !== null) {
                console.log('load folder: ' + e.originalEvent.state.parentId);
                documents.loadFolder(e.originalEvent.state.parentId, true);
                return false;
            }
            history.back();
            return true;
        });
    },

    loadFolder: function(id, isPopstate) {
        documents.docList.startProcess();
        connection.getJson('/Document/DocumentListOfFolder?repositoryId=' + documents.repositoryId + '&parentId=' + id, {
            onComplete: function () {
                documents.docList.endProcess();
            },
            onSuccess: function (data) {
                documents.folderNameEls.html('');
                $('<span class="linkify crumb" data-openfolder=""><i class="fa bi-house-fill fa-fw"></i></span>').appendTo(documents.folderNameEls);
                $.each(data.tree, function (i, el) {
                    $('<i class="fa bi-chevron-right"></i><span class="linkify crumb" data-openfolder="' + el.id + '">' + el.name + '</span>').appendTo(documents.folderNameEls);
                });
                if (data.folderName != "") {
                    $('<i class="fa bi-chevron-right"></i><strong>' + data.folderName + '</strong>').appendTo(documents.folderNameEls);
                }
                documents.folderNameEls.find('[data-openfolder]').click(function () {
                    documents.loadFolder($(this).attr('data-openfolder'));
                });
                if (!isPopstate) {
                    console.log('history add: ' + id);
                    history.pushState({"parentId": id}, null, null);
                }

                documents.dndUploadEl.attr('data-parentId', id);
                documents.uploadEl.attr('data-params', 'parentId=' + id);
                documents.newFolderEl.attr('data-params', 'parentId=' + id);
                if (data.hasWriteAccess) {
                    documents.newFolderEl.removeClass('disabled');
                    documents.uploadEl.removeClass('disabled');
                    documents.dndUploadEl.show();
                } else {
                    documents.newFolderEl.addClass('disabled');
                    documents.uploadEl.addClass('disabled');
                    documents.dndUploadEl.hide();
                }
                documents.refreshEl.attr('data-refresh', id);
                documents.container.attr('data-parentId', id);
                documents.docList.html($(data.content.trim()));
                documents.docList.find('.doc-row').click(documents.selectRow);
                documents.docList.find('[data-del]').on('click', function() {
                    documents.selectRow(null, $(this).parents('.doc-row'));
                    documents.deleteFile();
                });
                documents.docList.find('[data-access]').on('click', function() {
                    documents.selectRow(null, $(this).parents('.doc-row'));
                    slidein.openUrl($(this).attr('data-access'));
                });
                documents.docList.find('[data-open]').on('dblclick', function () {
                    var me = $(this);
                    window.open(me.attr('data-open'));
                });
                documents.docList.find('[data-openfolder]').click(function () {
                    var me = $(this);
                    documents.loadFolder(me.attr('data-openfolder'));
                    return false;
                });
            }
        });
    },

    selectRow: function(ev, rowEl) {
        var row = rowEl || $(this);
        documents.container.find('.doc-row.selected').removeClass('selected');
        row.addClass('selected');
    },

    unselectRow: function() {
        documents.container.find('.doc-row.selected').removeClass('selected');
    },

    initFilesContextmenu: function() {
        $menu = documents.container.find('.file-contextmenu');
        $menu.menu({
            select: function(event, ui) {
                event.preventDefault();
                var contextItem = ui.item.find(">a");
                if (ui.item.is('.disabled')) return;
                //
                var action = contextItem.attr("href");
                switch (action) {
                    case '#rename':
                        documents.startRenameFile(documents.container.menu.node);
                        documents.closeFilesMenu();
                        break;
                    case '#delete':
                        documents.container.menu.node.addClass('selected');
                        documents.closeFilesMenu();
                        documents.deleteFile();
                        break;
                }
            }
        }).hide();

        documents.container.delegate("[data-id]", "contextmenu", function(event) {
            var targetEl = $(this);
            documents.container.menu.node = targetEl;
            $(document).bind("keydown.filelist", function(event){
                if( event.which === $.ui.keyCode.ESCAPE ){
                    documents.closeFilesMenu();
                }
            }).bind("mousedown.filelist", function(event){
                // Close menu when clicked outside menu
                if( $(event.target).closest(".ui-menu-item").length === 0 ){
                    documents.closeFilesMenu();
                }
            });

            if (targetEl.attr('data-accessmode') === "read") {
                $menu.find('.rename .dropdown-item').addClass('disabled');
                $menu.find('.delete .dropdown-item').addClass('disabled');
                $menu.find('.rename.dropdown-item').addClass('disabled');
                $menu.find('.delete.dropdown-item').addClass('disabled');
            } else {
                $menu.find('.rename .dropdown-item').removeClass('disabled');
                $menu.find('.delete .dropdown-item').removeClass('disabled');
                $menu.find('.rename.dropdown-item').removeClass('disabled');
                $menu.find('.delete.dropdown-item').removeClass('disabled');
            }

            $menu
                .css("position", "absolute")
                .show()
                .position({my: "left top", at: "right top", of: event.originalEvent, collision: "fit"})
                .focus();

            return false;
        });
    },

    closeFilesMenu: function() {
        $menu = documents.container.find('.file-contextmenu');
        $(document).unbind("keydown.filelist, mousedown.filelist");
        $menu.hide();
        documents.container.menu.node = null;
    },

    startRenameFile: function(fileEl) {
        var fNameEl = fileEl.find('.fname');
        var name = fileEl.find('.name').text();
        var containerEl = $('<div class="input-group">' +
            '    <input type="text" class="form-control fname-edit" value="'+name+'" data-val="'+name+'" />' +
            '    <div class="input-group-append">' +
            '        <i class="btn btn-success" data-save="1">ändern</i>' +
            '    </div>' +
            '    <div class="input-group-append">' +
            '        <i class="btn btn-outline-danger" data-delete="1">×</i>' +
            '    </div>' +
            '</div>');
        var controlEl = containerEl.find('input');
        controlEl.on('keydown', function(event) {
            if (event.which === $.ui.keyCode.ENTER) {
                documents.renameFile(fileEl, $(this));
            } else if (event.which === $.ui.keyCode.ESCAPE) {
                documents.cancelRenameFile(controlEl, fileEl);
            }
        });
        fNameEl.removeClass('d-block').addClass('d-none');
        fNameEl.after(containerEl);
        controlEl.focus();
        containerEl.find('[data-save]').on('click', function() {
            documents.renameFile(fileEl, controlEl);
        });
        containerEl.find('[data-delete]').on('click', function() {
            documents.cancelRenameFile(controlEl, fNameEl);
        });
        // controlEl.on('blur', function() {
        //     documents.renameFile(fileEl, $(this));
        // });
    },

    renameFile: function(fileEl, controlEl) {
        var fNameEl = fileEl.find('.fname');
        if (controlEl.val() != controlEl.attr('data-val')) {
            connection.getJson('/Document/RenameFile', {
                data: {
                    id: fileEl.attr('data-id'),
                    name: controlEl.val()
                },
                onSuccess: function() {
                    fNameEl.find('.name').text(controlEl.val());
                    documents.cancelRenameFile(controlEl, fNameEl);
                    messaging.showGlobalMessage("success", null, "Die Datei/ Der Ordner wurde umbenannt.");
                },
                onError: function(data) {
                    messaging.showGlobalMessage("danger", null, data.error);
                    documents.cancelRenameFile(controlEl, fNameEl);
                }
            });
        } else {
            documents.cancelRenameFile(controlEl, fNameEl);
        }
    },

    cancelRenameFile: function(controlEl, fNameEl) {
        controlEl.closest('.input-group').remove();
        fNameEl.addClass('d-block').removeClass('d-none');
    },

    bodyClick: function(event) {
        if ($(event.target).parents('.documents').length == 0) {
            documents.unselectRow();
        }
    },

    showCreateFolder: function() {
        if (documents.newFolderEl.is('.disabled')) return;
        //
        var controlEl = documents.newFolderForm.find('input');
        documents.newFolderForm.show();
        controlEl.focus();
        controlEl.off('keydown').on('keydown', function(event) {
            if (event.which === $.ui.keyCode.ENTER) {
                documents.createFolder(controlEl, true);
            } else if (event.which === $.ui.keyCode.ESCAPE) {
                documents.newFolderForm.hide();
            }
        });
        documents.newFolderForm.find('[data-delete]').click(function (ev) {
            ev.stopPropagation();
            documents.newFolderForm.hide();
            return false;
        });
    },

    createFolder: function(controlEl, validateEmpty) {
        validateEmpty = validateEmpty || false;
        if (controlEl.val().trim() == '') {
            if (validateEmpty) {
                messaging.showGlobalMessage('danger', null, 'Gib einen Namen für den neuen Ordner ein.');
            } else {

            }
            return;
        }

        connection.loadJson('/Document/CreateFolder?name='+controlEl.val().trim()+'&repositoryId='+documents.repositoryId+'&'+documents.newFolderEl.attr('data-params'),
            null,
            function(data) {
                messaging.showGlobalMessage('success', null, 'Der Ordner wurde erstellt.');
                debugger;
                documents.loadFolder(data.parentId || '');
                controlEl.val('');
                documents.newFolderForm.hide();
            }
        );
    },

    uploadFile: function() {
        if (documents.uploadEl.is('.disabled')) return;
        //
        var me = $(this);
        upload.start(me, {
            params: {
                repositoryId: documents.repositoryId
            },
            success: function(data) {
                debugger;
                documents.loadFolder(data.parentId || '');
            }
        });
        return false;
    },

    deleteFile: function() {
        var row = documents.container.find('.doc-row.selected');
        if (row.length == 0) {
            messaging.showGlobalMessage('warning', null, 'Keine Datei ist ausgewählt.');
        }

        if (row.attr('data-type') == 1) {
            messaging.askYesNo('Datei löschen', 'Willst du die Datei "'+row.attr('data-name')+'" wirklich löschen?', function() {
                var href = row.attr('data-delete-url') || '/Document/Delete/'+row.attr('data-id');
                connection.loadJson(href, null, function() {
                    row.remove();
                    messaging.showGlobalMessage('success', null, 'Die Datei wurde gelöscht.');
                });
            });
        } else {
            messaging.askYesNo('Ordner löschen', 'Willst du den Ordner "'+row.attr('data-name')+'" mit allen enthaltenen Dateien/Ordnern löschen?', function() {
                var href = row.attr('data-delete-url') || '/Document/Delete/'+row.attr('data-id');
                connection.loadJson(href, null, function() {
                    row.remove();
                    messaging.showGlobalMessage('success', null, 'Der Ordner wurde gelöscht.');
                });
            });
        }
    }

};
window.documents = documents;

var posdocs = {
    container: null,
    folderNameEls: null,
    docList: null,
    uploadEl: null,
    dndUploadEl: null,
    newFolderEl: null,
    refreshEl: null,
    titleEl: null,
    newFolderForm: null,
    nextBtn: null,
    prevBtn: null,
    options: null,

    init: function(container, options) {
        posdocs.container = container;
        posdocs.options = options || {};
        posdocs.folderNameEls = container.find('.folder-name');
        posdocs.uploadEl = container.find('[data-upload]');
        posdocs.newFolderEl = container.find('[data-newfolder]');
        posdocs.refreshEl = container.find('[data-refresh]');
        posdocs.newFolderForm = container.find('.newfolder');
        posdocs.titleEl = posdocs.container.find('.title');
        posdocs.nextBtn = container.find('[data-next]');
        posdocs.prevBtn = container.find('[data-prev]');
        posdocs.dndUploadEl = $('.file-upload');
        posdocs.refreshEl.click(function() {
            posdocs.loadFolder(posdocs.refreshEl.attr('data-refresh'));
        });
        posdocs.container.find('[data-level-up]').click(function() {
            var me = $(this);
            posdocs.loadFolder(me.attr('data-level-up'));
        });
        posdocs.nextBtn.click(function() {
            posdocs.loadFolder(posdocs.refreshEl.attr('data-refresh'), posdocs.nextBtn.attr('data-next-page') * 100);
        });
        posdocs.prevBtn.click(function() {
            posdocs.loadFolder(posdocs.refreshEl.attr('data-refresh'), posdocs.nextBtn.attr('data-prev-page') * 100);
        });
        posdocs.initFilesContextmenu();

        posdocs.docList = container.find('#docs-');
        posdocs.loadFolder('');
        posdocs.uploadEl.click(posdocs.uploadFile);
        posdocs.newFolderEl.click(posdocs.showCreateFolder);
        $('body').click(posdocs.bodyClick);

        $(window).on("popstate", function(e) {
            if (e.originalEvent.state !== null) {
                console.log('load folder: ' + e.originalEvent.state.parentId);
                posdocs.loadFolder(e.originalEvent.state.parentId, true);
                return false;
            }
            history.back();
            return true;
        });
    },

    loadFolder: function(id, page) {
        posdocs.docList.startProcess();
        connection.getJson('/TemplateAssets/ListFolder?ParentId=' + (id || '') + '&paging=' + (page || '0'), {
            onComplete: function () {
                posdocs.docList.endProcess();
            },
            onSuccess: function (data) {
                posdocs.folderNameEls.html('');
                $('<span class="linkify crumb" data-openfolder=""><i class="fa bi-house-fill fa-2x"></i></span>').appendTo(posdocs.folderNameEls);
                $.each(data.tree, function (i, el) {
                    $('<i class="fa bi-chevron-right"></i><span class="linkify crumb" data-openfolder="' + el.id + '">' + el.name + '</span>').appendTo(posdocs.folderNameEls);
                });
                if (data.folderName !== "") {
                    $('<i class="fa bi-chevron-right"></i><strong>' + data.folderName + '</strong>').appendTo(posdocs.folderNameEls);
                }
                posdocs.folderNameEls.find('[data-openfolder]').click(function () {
                    posdocs.loadFolder($(this).attr('data-openfolder'));
                });
                posdocs.container.find('[data-level-up]').attr('data-level-up', data.parentId || '');
                posdocs.refreshEl.attr('data-refresh', id);
                posdocs.dndUploadEl.attr('data-parentId', id);
                posdocs.uploadEl.attr('data-params', 'parentId=' + id);
                posdocs.newFolderEl.attr('data-params', 'parentId=' + id);
                posdocs.docList.html($(data.content.trim()));
                onContentReady(posdocs.docList);
                posdocs.docList.find('.doc-row').click(posdocs.selectRow);
                posdocs.docList.find('[data-del]').on('click', function () {
                    posdocs.selectRow(null, $(this).parents('.doc-row'));
                    posdocs.deleteFile();
                });
                posdocs.docList.find('[data-file]').on('click', function () {
                    var me = $(this);
                    if (posdocs.options.onFileClick) posdocs.options.onFileClick(me);
                });
                posdocs.docList.find('[data-open]').on('dblclick', function () {
                    var me = $(this);
                    window.open(me.attr('data-open'));
                });
                posdocs.docList.find('[data-openfolder]').click(function () {
                    var me = $(this);
                    posdocs.loadFolder(me.attr('data-openfolder'));
                    return false;
                });
                posdocs.nextBtn.attr('data-next-page', data.paging.CurrentPage + 1);
                posdocs.nextBtn.prop("disabled", data.paging.CurrentPage >= data.paging.TotalPages);
                posdocs.prevBtn.attr('data-prev-page', data.paging.CurrentPage - 1);
                posdocs.prevBtn.prop("disabled", data.paging.CurrentPage <= 0);
            }
        });
    },

    selectRow: function(ev, rowEl) {
        var row = rowEl || $(this);
        posdocs.container.find('.doc-row.selected').removeClass('selected');
        row.addClass('selected');
    },

    unselectRow: function() {
        posdocs.container.find('.doc-row.selected').removeClass('selected');
    },

    initFilesContextmenu: function() {
        $menu = posdocs.container.find('.file-contextmenu');
        $menu.menu({
            select: function(event, ui) {
                event.preventDefault();
                var contextItem = ui.item.find(">a");
                if (ui.item.is('.disabled')) return;
                //
                var action = contextItem.attr("href");
                switch (action) {
                    case '#toggle-hide':
                        connection.getJson('/TemplateAssets/ToggleHidden', {
                            data: {
                                id: posdocs.container.menu.node.attr('data-id'),
                            },
                        });
                        posdocs.closeFilesMenu();
                        break;
                    case '#rename':
                        posdocs.startRenameFile(posdocs.container.menu.node);
                        posdocs.closeFilesMenu();
                        break;
                    case '#delete':
                        posdocs.container.menu.node.addClass('selected');
                        posdocs.closeFilesMenu();
                        posdocs.deleteFile();
                        break;
                }
            }
        }).hide();

        posdocs.container.delegate("[data-id]", "contextmenu", function(event) {
            var targetEl = $(this);
            posdocs.container.menu.node = targetEl;
            $(document).bind("keydown.filelist", function(event){
                if( event.which === $.ui.keyCode.ESCAPE ){
                    posdocs.closeFilesMenu();
                }
            }).bind("mousedown.filelist", function(event){
                // Close menu when clicked outside menu
                if( $(event.target).closest(".ui-menu-item").length === 0 ){
                    posdocs.closeFilesMenu();
                }
            });

            if (targetEl.attr('data-accessmode') === "read") {
                $menu.find('.rename').addClass('disabled');
                $menu.find('.delete').addClass('disabled');
            } else {
                $menu.find('.rename').removeClass('disabled');
                $menu.find('.delete').removeClass('disabled');
            }

            $menu
                .css("position", "absolute")
                .show()
                .position({my: "left top", at: "right top", of: event.originalEvent, collision: "fit"})
                .focus();

            return false;
        });
    },

    closeFilesMenu: function() {
        $menu = posdocs.container.find('.file-contextmenu');
        $(document).unbind("keydown.filelist, mousedown.filelist");
        $menu.hide();
        posdocs.container.menu.node = null;
    },

    startRenameFile: function(fileEl) {
        var fNameEl = fileEl.find('.fname');
        var name = fileEl.find('.name').text();
        var containerEl = $('<div class="input-group">' +
            '    <input type="text" class="form-control fname-edit" value="'+name+'" data-val="'+name+'" />' +
            '    <div class="input-group-append">' +
            '        <i class="btn btn-success" data-save="1">ändern</i>' +
            '    </div>' +
            '    <div class="input-group-append">' +
            '        <i class="btn btn-outline-danger" data-delete="1">×</i>' +
            '    </div>' +
            '</div>');
        var controlEl = containerEl.find('input');
        controlEl.on('keydown', function(event) {
            if (event.which === $.ui.keyCode.ENTER) {
                posdocs.renameFile(fileEl, $(this));
            } else if (event.which === $.ui.keyCode.ESCAPE) {
                posdocs.cancelRenameFile(controlEl, fileEl);
            }
        });
        fNameEl.removeClass('d-block').addClass('d-none');
        fNameEl.after(containerEl);
        controlEl.focus();
        containerEl.find('[data-save]').on('click', function() {
            posdocs.renameFile(fileEl, controlEl);
        });
        containerEl.find('[data-delete]').on('click', function() {
            posdocs.cancelRenameFile(controlEl, fNameEl);
        });
        // controlEl.on('blur', function() {
        //     posdocs.renameFile(fileEl, $(this));
        // });
    },

    renameFile: function(fileEl, controlEl) {
        var fNameEl = fileEl.find('.fname');
        if (controlEl.val() !== controlEl.attr('data-val')) {
            connection.getJson('/TemplateAssets/RenameFile', {
                data: {
                    id: fileEl.attr('data-id'),
                    name: controlEl.val()
                },
                onSuccess: function() {
                    fNameEl.find('.name').text(controlEl.val());
                    posdocs.cancelRenameFile(controlEl, fNameEl);
                    messaging.showGlobalMessage("success", null, "Die Datei/ Der Ordner wurde umbenannt.");
                },
                onError: function(data) {
                    messaging.showGlobalMessage("danger", null, data.error);
                    posdocs.cancelRenameFile(controlEl, fNameEl);
                }
            });
        } else {
            posdocs.cancelRenameFile(controlEl, fNameEl);
        }
    },

    cancelRenameFile: function(controlEl, fNameEl) {
        controlEl.closest('.input-group').remove();
        fNameEl.addClass('d-block').removeClass('d-none');
    },

    showCreateFolder: function() {
        if (posdocs.newFolderEl.is('.disabled')) return;
        //
        var controlEl = posdocs.newFolderForm.find('input');
        posdocs.newFolderForm.show();
        controlEl.focus();
        controlEl.off('keydown').on('keydown', function(event) {
            if (event.which === $.ui.keyCode.ENTER) {
                posdocs.createFolder(controlEl, true);
            } else if (event.which === $.ui.keyCode.ESCAPE) {
                posdocs.newFolderForm.hide();
            }
        });

        posdocs.newFolderForm.find('[data-save]').off('click').click(function (ev) {
            posdocs.createFolder(controlEl, true);
        });

        posdocs.newFolderForm.find('[data-delete]').click(function (ev) {
            ev.stopPropagation();
            posdocs.newFolderForm.hide();
            return false;
        });
    },

    createFolder: function(controlEl, validateEmpty) {
        validateEmpty = validateEmpty || false;
        if (controlEl.val().trim() === '') {
            if (validateEmpty) {
                messaging.showGlobalMessage('danger', null, 'Gib einen Namen für den neuen Ordner ein.');
            } else {

            }
            return;
        }

        connection.loadJson('/TemplateAssets/CreateFolder?name='+controlEl.val().trim()+'&'+posdocs.newFolderEl.attr('data-params'),
            null,
            function(data) {
                messaging.showGlobalMessage('success', null, 'Der Ordner wurde erstellt.');
                posdocs.loadFolder(data.parentId || '');
                controlEl.val('');
                posdocs.newFolderForm.hide();
            }
        );
    },

    uploadFile: function() {
        if (posdocs.uploadEl.is('.disabled')) return;
        //
        var me = $(this);
        upload.start(me, {
            params: {
            },
            success: function(data) {
                posdocs.loadFolder(data.parentId || '');
            }
        });
        return false;
    },

    deleteFile: function() {
        var row = posdocs.container.find('.doc-row.selected');
        if (row.length === 0) {
            messaging.showGlobalMessage('warning', null, 'Keine Datei ist ausgewählt.');
        }

        if (row.attr('data-type') == 1) {
            messaging.askYesNo('Datei löschen', 'Willst du die Datei "'+row.attr('data-name')+'" wirklich löschen?', function() {
                connection.loadJson('/TemplateAssets/Delete/'+row.attr('data-id'), null, function() {
                    row.remove();
                    messaging.showGlobalMessage('success', null, 'Die Datei wurde gelöscht.');
                });
            });
        } else {
            messaging.askYesNo('Ordner löschen', 'Willst du den Ordner "'+row.attr('data-name')+'" mit allen enthaltenen Dateien/Ordnern löschen?', function() {
                connection.loadJson('/TemplateAssets/Delete/'+row.attr('data-id'), null, function() {
                    row.remove();
                    messaging.showGlobalMessage('success', null, 'Der Ordner wurde gelöscht.');
                });
            });
        }
    },

};
window.posdocs = posdocs;
